const Json2csvParser = require("json2csv").Parser;
export default class Csvhelper {
  createFileURL(dataArray, fields) {
    let createDataUriFromString = (str) => {
      var bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      var blob = new Blob([bom, str], { type: "text/csv" });
      return window.URL.createObjectURL(blob);
    };

    const json2csvParser = new Json2csvParser({ fields: fields });
    const csv = json2csvParser.parse(dataArray);
    return createDataUriFromString(csv);
  }
}
